export const isColombianLocale = (locale: countriesCodes) => {
  if (!locale) return true;
  return locale === countriesCodes.colombia;
};

export enum countriesCodes {
  spain = 'es-ES',
  colombia = 'es-CO',
  portugal = 'pt-PT',
  italy = 'it-IT',
  france = 'fr-FR',
  peru = 'es-PE'
}

export const availableLocale = {
  [countriesCodes.spain]: 'España',
  [countriesCodes.colombia]: 'Colombia',
  [countriesCodes.portugal]: 'Portugal',
  [countriesCodes.italy]: 'Italia',
  [countriesCodes.france]: 'France',
  [countriesCodes.peru]: 'Peru'
};
